import React, { useEffect, useMemo, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { ListCategories, Select } from 'src/components/index'

export interface MultipleSelectExtraProps {
  noMultiple?: boolean
  clear?: boolean
}

interface MultipleSelectProps extends MultipleSelectExtraProps {
  options: ISelect[]
  label: string
  onChange: (values: ISelect[]) => void
}

export const MultipleSelect = ({
  options,
  label,
  onChange,
  noMultiple = false,
  clear = false,
}: MultipleSelectProps) => {
  useEffect(() => {
    if (clear) onCallBack([])
  }, [clear])

  const [items, setItems] = useState<ISelect[]>([])

  const onRemove = (item: ISelect) => {
    const index = items.findIndex(i => i.value === item.value)
    const newItems = [...items]
    newItems.splice(index, 1)
    onCallBack(newItems)
  }

  const onCallBack = (response: ISelect[]) => {
    setItems(response)
    onChange(response)
  }

  const filteredItems = useMemo(() => {
    return options.filter(u => items.findIndex(i => i.value === u.value) === -1)
  }, [items, options])

  const getOptionSelected = (): ISelect => {
    const defaultOption = { label: 'Selecciona una opción', value: null }
    if (!noMultiple) return defaultOption
    return items.length > 0 ? items[0] : defaultOption
  }

  return (
    <Row>
      <Col xl={12}>
        <Select
          label={label}
          options={filteredItems}
          value={getOptionSelected()}
          onChange={(option: ISelect) => {
            const newItems = noMultiple ? [option] : [...items, option]
            onCallBack(newItems)
          }}
        />
      </Col>

      {!noMultiple && (
        <Col xl={12}>
          <ListCategories items={items} onRemove={onRemove} />
        </Col>
      )}
    </Row>
  )
}
